<p-dialog [(visible)]="display"
          [closable]="false"
          [styleClass]="dialogClass + ' ' + extraCssClass"
          [style]="_style"
          position="center"
          [closeOnEscape]="true"
          [focusOnShow]="true"
          [dismissableMask]="true"
          [modal]="true"
          [draggable]="draggable"
          [contentStyle]="_contentStyle"
          [appendTo]="appendTo">
  <ng-template #header>
    <ng-container *ngTemplateOutlet="headerTpl">
    </ng-container>
  </ng-template>
  @if (renderBody) {
    <ng-container *ngTemplateOutlet="bodyTpl">
    </ng-container>
  }
  <ng-template #footer>
    <ng-container *ngTemplateOutlet="footerTpl"></ng-container>
  </ng-template>
</p-dialog>
